// extracted by mini-css-extract-plugin
export default {"hidden":"confirm-dtg-popup__hidden___bXQdi","uploadAnotherButton":"confirm-dtg-popup__uploadAnotherButton___Ye6yJ"};